<div class="space-y-5">
  <!-- Header -->
  <div class="flex items-center justify-between">
    <h2 class="text-2xl font-bold tracking-tight text-primary-800 dark:text-primary-400">Repayments</h2>
    <div class="flex items-center gap-2">
      @if (permissionService.canUploadPayment()) {
      <button (click)="openUploadModal()"
        class="px-3 py-1.5 rounded-lg text-slate-600 dark:text-slate-400 hover:text-slate-800 dark:text-slate-100 bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-800/60 border border-slate-200 dark:border-slate-700 transition-colors flex items-center gap-1.5 text-xs font-semibold">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
        </svg>
        <span>Upload</span>
      </button>
      }
      @if (permissionService.canRecordPayment()) {
      <button (click)="openRecordModal()"
        class="px-3 py-1.5 rounded-lg bg-primary-800 hover:bg-primary-900 text-white flex items-center gap-1.5 text-xs font-semibold transition-colors shadow-sm">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
        </svg>
        <span>Record Repayment</span>
      </button>
      }
      <button (click)="loadRepayments()"
        class="px-3 py-1.5 rounded-lg text-slate-600 dark:text-slate-400 hover:text-slate-800 dark:text-slate-100 bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-800/60 border border-slate-200 dark:border-slate-700 transition-colors flex items-center gap-1.5 text-xs font-semibold"
        title="Refresh">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
        <span>Refresh</span>
      </button>
    </div>
  </div>

  <!-- Search and Filter -->
  <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
    <div class="w-full sm:w-96">
      <app-search [placeholder]="'Search by applicant name'" (valueChange)="onSearch($event)"></app-search>
    </div>
    <div class="w-full sm:w-auto">
      <app-institution-filter
        [statusOptions]="loanStatusOptions"
        (onSaveEvent)="filterRepayments($event)"
        (resetClickEvent)="resetRepaymentFilters()">
      </app-institution-filter>
    </div>
  </div>

  <!-- Table Container -->
  <div class="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 shadow-sm overflow-hidden">
    <!-- Table Header -->
    <div class="grid grid-cols-11 gap-4 px-5 py-3 bg-slate-50 dark:bg-slate-800/60 border-b border-slate-200 dark:border-slate-700">
      <div class="col-span-1 text-left"><p class="text-xs font-semibold text-slate-400">Date</p></div>
      <div class="col-span-1 text-left"><p class="text-xs font-semibold text-slate-400">ID</p></div>
      <div class="col-span-1 text-left"><p class="text-xs font-semibold text-slate-400">Applicant</p></div>
      <div class="col-span-1 text-left"><p class="text-xs font-semibold text-slate-400">Reference</p></div>
      <div class="col-span-1 text-left"><p class="text-xs font-semibold text-slate-400">Principal</p></div>
      <div class="col-span-1 text-left"><p class="text-xs font-semibold text-slate-400">Interest</p></div>
      <div class="col-span-1 text-left"><p class="text-xs font-semibold text-slate-400">Monthly</p></div>
      <div class="col-span-1 text-left"><p class="text-xs font-semibold text-slate-400">Amount Paid</p></div>
      <div class="col-span-1 text-left"><p class="text-xs font-semibold text-slate-400">Type</p></div>
      <div class="col-span-1 text-left"><p class="text-xs font-semibold text-slate-400">Status</p></div>
      <div class="col-span-1 text-center"><p class="text-xs font-semibold text-slate-400">Action</p></div>
    </div>

    <!-- Table Body -->
    <div class="overflow-y-auto max-h-[420px]">
      @if (isLoading) {
      <div class="flex items-center justify-center py-20">
        <app-progress-loader></app-progress-loader>
      </div>
      } @else if (repayments && repayments.length > 0) {
      @for (repayment of repayments; track repayment.id) {
      <app-single-product-repayment-table
        [repayment]="repayment"
        [productId]="productId"
        (onDelete)="onDeleteRequest($event)">
      </app-single-product-repayment-table>
      }
      } @else {
      <div class="flex flex-col items-center justify-center py-24 text-center px-4">
        <div class="w-14 h-14 bg-slate-50 dark:bg-slate-800/60 rounded-full flex items-center justify-center mx-auto mb-4 border border-slate-100 dark:border-slate-700/50">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-slate-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
          </svg>
        </div>
        <h3 class="text-sm font-bold text-slate-800 dark:text-slate-100">No Repayments Found</h3>
        <p class="text-xs text-slate-500 dark:text-slate-400 mt-1.5 leading-relaxed max-w-xs">There are no repayment records for this product yet.</p>
      </div>
      }
    </div>

    <!-- Pagination -->
    @if (repayments && repayments.length > 0) {
    <div class="border-t border-slate-100 dark:border-slate-700/50 px-4">
      <app-pagination [totalItems]="totalItems" [itemsPerPage]="itemsPerPage" [currentPage]="currentPage"
        (pageChange)="onPageChange($event)">
      </app-pagination>
    </div>
    }
  </div>
</div>

<!-- Record Repayment Modal -->
@if (showRecordModal) {
<div class="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/40 backdrop-blur-md animate-in fade-in duration-300">
  <div class="absolute inset-0" (click)="closeRecordModal()"></div>
  <div class="relative bg-white dark:bg-slate-800 rounded-2xl shadow-[0_32px_64px_-12px_rgba(0,0,0,0.14),0_0_0_1px_rgba(0,0,0,0.02)] w-full max-w-md overflow-hidden animate-in zoom-in-95 slide-in-from-bottom-4 duration-300">
    <!-- Top Brand Glow -->
    <div class="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-primary/40 via-primary to-primary/40"></div>

    <!-- Modal Header -->
    <div class="flex items-center justify-between px-6 py-4 border-b border-slate-100 dark:border-slate-700/50 bg-slate-50 dark:bg-slate-800/60 backdrop-blur-md">
      <div>
        <div class="flex items-center gap-2 mb-0.5">
          <div class="w-2 h-2 rounded-full bg-primary-800 animate-pulse"></div>
          <h3 class="text-xs font-bold text-slate-900 dark:text-white uppercase tracking-widest">Record Repayment</h3>
        </div>
        <p class="text-[11px] text-slate-500 dark:text-slate-400">Fill in the payment details below</p>
      </div>
      <button (click)="closeRecordModal()"
        class="w-8 h-8 flex items-center justify-center text-slate-400 hover:text-slate-900 dark:text-white hover:bg-white dark:bg-slate-800 hover:shadow-lg rounded-full transition-all duration-300 group">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 group-hover:rotate-90 transition-transform duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <form [formGroup]="recordForm" (ngSubmit)="submitRepayment()" class="p-6 space-y-4">
      <div>
        <label class="block text-xs font-semibold text-slate-600 dark:text-slate-400 mb-1.5">Loan Reference <span class="text-error">*</span></label>
        <div class="flex gap-2">
          <div class="flex-1">
            <app-custom-input formControlName="loanReference" [placeholder]="'e.g. LN-2024-001'" [isRequired]="true"></app-custom-input>
          </div>
          <button type="button" (click)="lookupLoan()" [disabled]="isLookingUp || !recordForm.get('loanReference')?.value"
            class="px-3 h-10 rounded-lg bg-slate-100 dark:bg-slate-900 hover:bg-slate-200 dark:bg-slate-700 text-slate-700 dark:text-slate-300 text-xs font-semibold transition-colors disabled:opacity-40 flex-shrink-0">
            @if (isLookingUp) {
            <svg class="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg>
            } @else {
            Lookup
            }
          </button>
        </div>
        @if (lookupError) {
        <p class="text-xs text-error mt-1">{{ lookupError }}</p>
        }
        @if (resolvedLoan) {
        <div class="mt-2 flex items-center gap-2 px-3 py-2 bg-emerald-50 dark:bg-emerald-950/40 border border-emerald-100 dark:border-emerald-900 rounded-lg">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 text-emerald-500 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
          <div class="min-w-0">
            <p class="text-[11px] font-bold text-emerald-700 truncate">{{ resolvedLoan.user?.firstName }} {{ resolvedLoan.user?.lastName }}</p>
            <p class="text-[10px] text-emerald-600">₵{{ (resolvedLoan.amount ?? resolvedLoan.principal_amount) | number:'1.2-2' }} · {{ resolvedLoan.status }}</p>
          </div>
        </div>
        }
        @if (recordForm.get('loanReference')?.invalid && recordForm.get('loanReference')?.touched) {
        <p class="text-xs text-error mt-1">Loan reference is required</p>
        }
      </div>

      <div>
        <label class="block text-xs font-semibold text-slate-600 dark:text-slate-400 mb-1.5">Repayment Type <span class="text-error">*</span></label>
        <app-custom-select-input
          formControlName="type"
          [options]="repaymentTypes"
          [placeholder]="'Select repayment type'">
        </app-custom-select-input>
        @if (recordForm.get('type')?.invalid && recordForm.get('type')?.touched) {
        <p class="text-xs text-error mt-1">Repayment type is required</p>
        }
      </div>

      <div>
        <label class="block text-xs font-semibold text-slate-600 dark:text-slate-400 mb-1.5">Transaction ID <span class="text-error">*</span></label>
        <app-custom-input formControlName="transactionId" [placeholder]="'Enter transaction ID'" [isRequired]="true"></app-custom-input>
        @if (recordForm.get('transactionId')?.invalid && recordForm.get('transactionId')?.touched) {
        <p class="text-xs text-error mt-1">Transaction ID is required</p>
        }
      </div>

      <div>
        <label class="block text-xs font-semibold text-slate-600 dark:text-slate-400 mb-1.5">Amount (₵) <span class="text-error">*</span></label>
        <app-custom-input formControlName="amount" [type]="'number'" [placeholder]="'0.00'" [isRequired]="true"></app-custom-input>
        @if (recordForm.get('amount')?.invalid && recordForm.get('amount')?.touched) {
        <p class="text-xs text-error mt-1">A valid amount is required</p>
        }
      </div>

      <div>
        <label class="block text-xs font-semibold text-slate-600 dark:text-slate-400 mb-1.5">Date <span class="text-error">*</span></label>
        <app-custom-input formControlName="date" [type]="'date'" [isRequired]="true" [max]="today"></app-custom-input>
        @if (recordForm.get('date')?.invalid && recordForm.get('date')?.touched) {
        <p class="text-xs text-error mt-1">Date is required</p>
        }
      </div>

      <div>
        <label class="block text-xs font-semibold text-slate-600 dark:text-slate-400 mb-1.5">Comment</label>
        <app-custom-input formControlName="comment" [placeholder]="'Optional note'" [isTextarea]="true" [rows]="3"></app-custom-input>
      </div>

      <div class="flex gap-3 pt-1">
        <button type="button" (click)="closeRecordModal()"
          class="flex-1 h-11 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-400 text-sm font-semibold hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-800/60 transition-colors">
          Cancel
        </button>
        <button type="submit" [disabled]="isSubmitting"
          class="flex-1 h-11 rounded-xl bg-primary-800 hover:bg-primary-900 text-white text-sm font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
          {{ isSubmitting ? 'Saving...' : 'Record Repayment' }}
        </button>
      </div>
    </form>
  </div>
</div>
}

<!-- Upload Repayments Modal -->
@if (showUploadModal) {
<div class="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/40 backdrop-blur-md animate-in fade-in duration-300">
  <div class="absolute inset-0" (click)="closeUploadModal()"></div>
  <div class="relative bg-white dark:bg-slate-800 rounded-2xl shadow-[0_32px_64px_-12px_rgba(0,0,0,0.14),0_0_0_1px_rgba(0,0,0,0.02)] w-full max-w-lg overflow-hidden animate-in zoom-in-95 slide-in-from-bottom-4 duration-300">
    <!-- Top Brand Glow -->
    <div class="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-primary/40 via-primary to-primary/40"></div>

    <!-- Modal Header -->
    <div class="flex items-center justify-between px-6 py-4 border-b border-slate-100 dark:border-slate-700/50 bg-slate-50 dark:bg-slate-800/60 backdrop-blur-md">
      <div>
        <div class="flex items-center gap-2 mb-0.5">
          <div class="w-2 h-2 rounded-full bg-primary-800 animate-pulse"></div>
          <h3 class="text-xs font-bold text-slate-900 dark:text-white uppercase tracking-widest">Upload Repayments</h3>
        </div>
        <p class="text-[11px] text-slate-500 dark:text-slate-400">CSV only, max 3MB</p>
      </div>
      <button (click)="closeUploadModal()"
        class="w-8 h-8 flex items-center justify-center text-slate-400 hover:text-slate-900 dark:text-white hover:bg-white dark:bg-slate-800 hover:shadow-lg rounded-full transition-all duration-300 group">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 group-hover:rotate-90 transition-transform duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <div class="p-6 space-y-4">
      @if (uploadPhase === 'idle' || uploadPhase === 'uploading') {
      <input #uploadFileInput type="file" accept=".csv" class="hidden" (change)="onUploadFileSelected($event)" />

      <div (click)="uploadFileInputRef.nativeElement.click()"
        class="border-2 border-dashed rounded-xl p-8 flex flex-col items-center justify-center gap-3 cursor-pointer hover:border-primary-800/40 hover:bg-primary-800/5 transition-colors group"
        [class.border-rose-300]="uploadFieldError"
        [class.border-slate-200]="!uploadFieldError"
        [class.dark:border-slate-700]="!uploadFieldError">
        <div class="w-10 h-10 rounded-full bg-slate-100 dark:bg-slate-900 flex items-center justify-center group-hover:bg-primary-800/10 transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-slate-400 group-hover:text-primary-800 dark:text-primary-400 transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
          </svg>
        </div>
        @if (uploadFile) {
        <div class="text-center">
          <p class="text-xs font-semibold text-slate-800 dark:text-slate-100">{{ uploadFile.name }}</p>
          <p class="text-[10px] text-slate-400 mt-0.5">Click to change file</p>
        </div>
        } @else {
        <div class="text-center">
          <p class="text-xs font-semibold text-slate-600 dark:text-slate-400">Click to select file</p>
          <p class="text-[10px] text-slate-400 mt-0.5">CSV only, max 3MB</p>
        </div>
        }
      </div>

      @if (uploadFieldError) {
      <p class="text-xs text-rose-500 -mt-2">{{ uploadFieldError }}</p>
      }

      <!-- Template help -->
      <div class="px-3 py-2.5 bg-slate-50 dark:bg-slate-900/50 border border-slate-100 dark:border-slate-700/50 rounded-lg space-y-1.5">
        <p class="text-[11px] font-semibold text-slate-600 dark:text-slate-400">Expected columns</p>
        <p class="text-[10px] font-mono text-slate-500 dark:text-slate-400 break-all">{{ csvTemplateHeaders.join(', ') }}</p>
        <button type="button" (click)="downloadTemplate()"
          class="text-[11px] font-semibold text-primary-800 dark:text-primary-400 hover:underline">
          Download sample CSV
        </button>
      </div>

      <div class="flex gap-3">
        <button (click)="closeUploadModal()"
          class="flex-1 h-11 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-400 text-sm font-semibold hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-800/60 transition-colors">
          Cancel
        </button>
        <button (click)="submitUpload()" [disabled]="!uploadFile || !!uploadFieldError || isUploading"
          class="flex-1 h-11 rounded-xl bg-primary-800 hover:bg-primary-900 text-white text-sm font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
          {{ isUploading ? 'Uploading...' : 'Upload' }}
        </button>
      </div>
      }

      @if (uploadPhase === 'processing') {
      <div class="flex flex-col items-center justify-center py-10 gap-3">
        <svg class="w-8 h-8 animate-spin text-primary-800 dark:text-primary-400" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
        </svg>
        <p class="text-xs font-semibold text-slate-700 dark:text-slate-300">Processing&hellip;</p>
        <p class="text-[11px] text-slate-400 text-center max-w-xs">Your file has been uploaded and rows are being recorded. This usually takes a few seconds.</p>
      </div>
      <button (click)="closeUploadModal()"
        class="w-full h-11 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-400 text-sm font-semibold hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors">
        Close
      </button>
      }

      @if (uploadPhase === 'result') {
      <!-- Polling error / timeout -->
      @if (pollError) {
      <div class="px-4 py-3 bg-rose-50 dark:bg-rose-950/40 border border-rose-100 dark:border-rose-900 rounded-xl">
        <p class="text-xs font-bold text-rose-700 dark:text-rose-400">{{ pollError }}</p>
        <p class="text-[11px] text-rose-600 dark:text-rose-400/80 mt-1">The file may still be processing on the server. Refresh the repayments list later.</p>
      </div>
      } @else if (pollTimedOut && !importResult) {
      <div class="px-4 py-3 bg-amber-50 dark:bg-amber-950/40 border border-amber-100 dark:border-amber-900 rounded-xl space-y-2">
        <p class="text-xs font-bold text-amber-700 dark:text-amber-400">Still processing</p>
        <p class="text-[11px] text-amber-600 dark:text-amber-400/80">This is taking longer than expected. Processing continues on the server — check back later.</p>
        <button (click)="recheckImport()" [disabled]="isRechecking"
          class="text-[11px] font-semibold text-amber-700 dark:text-amber-400 underline disabled:opacity-50">
          {{ isRechecking ? 'Checking…' : 'Check again' }}
        </button>
      </div>
      } @else if (importResult) {
      <!-- Summary -->
      @if (importOutcome === 'success') {
      <div class="flex items-start gap-3 px-4 py-3 bg-emerald-50 dark:bg-emerald-950/40 border border-emerald-100 dark:border-emerald-900 rounded-xl">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-emerald-500 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
        <div>
          <p class="text-xs font-bold text-emerald-700 dark:text-emerald-400">Upload complete</p>
          <p class="text-[11px] text-emerald-600 dark:text-emerald-400/80 mt-0.5">All {{ importResult.success }} of {{ importResult.total }} rows recorded.</p>
        </div>
      </div>
      } @else if (importOutcome === 'partial') {
      <div class="flex items-start gap-3 px-4 py-3 bg-amber-50 dark:bg-amber-950/40 border border-amber-100 dark:border-amber-900 rounded-xl">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/></svg>
        <div>
          <p class="text-xs font-bold text-amber-700 dark:text-amber-400">Partially recorded</p>
          <p class="text-[11px] text-amber-600 dark:text-amber-400/80 mt-0.5">{{ importResult.success }} of {{ importResult.total }} rows recorded, {{ importResult.failed }} failed.</p>
        </div>
      </div>
      } @else {
      <div class="flex items-start gap-3 px-4 py-3 bg-rose-50 dark:bg-rose-950/40 border border-rose-100 dark:border-rose-900 rounded-xl">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-rose-500 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
        <div>
          <p class="text-xs font-bold text-rose-700 dark:text-rose-400">Upload failed</p>
          <p class="text-[11px] text-rose-600 dark:text-rose-400/80 mt-0.5">None of the {{ importResult.total }} rows could be recorded.</p>
        </div>
      </div>
      }

      <!-- Row errors table -->
      @if (visibleRowErrors.length > 0) {
      <div class="border border-slate-200 dark:border-slate-700 rounded-xl overflow-hidden">
        <div class="flex items-center justify-between px-3 py-2 bg-slate-50 dark:bg-slate-800/60 border-b border-slate-200 dark:border-slate-700">
          <p class="text-[11px] font-semibold text-slate-600 dark:text-slate-400">
            Failed rows
            @if (hiddenErrorCount > 0) {
            <span class="font-normal text-slate-400">(showing first {{ visibleRowErrors.length }} of {{ importResult.failed }} errors)</span>
            }
          </p>
          <button (click)="downloadErrorsCsv()"
            class="text-[11px] font-semibold text-primary-800 dark:text-primary-400 hover:underline">
            Download errors as CSV
          </button>
        </div>
        <div class="max-h-52 overflow-y-auto">
          <table class="w-full text-left">
            <thead class="sticky top-0 bg-white dark:bg-slate-800">
              <tr class="border-b border-slate-100 dark:border-slate-700/50">
                <th class="px-3 py-1.5 text-[10px] font-semibold text-slate-400 w-12">Row</th>
                <th class="px-3 py-1.5 text-[10px] font-semibold text-slate-400 w-32">Loan Reference</th>
                <th class="px-3 py-1.5 text-[10px] font-semibold text-slate-400">Error</th>
              </tr>
            </thead>
            <tbody>
              @for (rowError of visibleRowErrors; track $index) {
              <tr class="border-b border-slate-50 dark:border-slate-700/30 last:border-0">
                <td class="px-3 py-1.5 text-[11px] text-slate-500 dark:text-slate-400">{{ rowError.row }}</td>
                <td class="px-3 py-1.5 text-[11px] font-mono text-slate-600 dark:text-slate-300">{{ rowError.reference || '—' }}</td>
                <td class="px-3 py-1.5 text-[11px] text-rose-600 dark:text-rose-400">{{ rowError.error }}</td>
              </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
      }
      }

      <button (click)="closeUploadModal()"
        class="w-full h-11 rounded-xl bg-primary-800 hover:bg-primary-900 text-white text-sm font-semibold transition-colors">
        Done
      </button>
      }
    </div>
  </div>
</div>
}

<!-- Delete Confirmation Dialog -->
@if (showDeleteDialog) {
<app-confirmation-dialog
  [title]="'Delete Repayment'"
  [message]="'Are you sure you want to delete this repayment record? This action cannot be undone.'"
  [confirmText]="'Delete'"
  [type]="'danger'"
  (onConfirm)="confirmDelete()"
  (onCancel)="cancelDelete()">
</app-confirmation-dialog>
}
